module.exports = __webpack_public_path__ + "img/div1s.1abed8f8.jpg";